import Testimonial from "../../molecules/Testimonial";
import "./styles.scss";

const Testimonials = (props) => {
  return (
    <div className={`testimonials testimonials--${props.theme}`}>
      {props.testimonials.map(function (item, index) {
        return (
          <Testimonial
            testimonial={item}
            starRate={5}
            nameOnBottom={true}
            key={`testimonials-${index}`}
          />
        );
      })}
    </div>
  );
};

export default Testimonials;
